import { mixed, object } from "yup";

import {
  AdditionalInsuredInput,
  Relationship,
} from "@covertree/new-business-graphql";
import { firstName, lastName } from "@covertree/utils";

export const relationshipOptions: {
  value: Relationship;
  label: string;
}[] = [
  {
    value: Relationship.Spouse,
    label: Relationship.Spouse,
  },
  {
    value: Relationship.OtherFamily,
    label: "Other Family",
  },
  {
    value: Relationship.Friend,
    label: "Friend",
  },
  {
    value: Relationship.Owner,
    label: "Second Owner",
  },
  {
    value: Relationship.Other,
    label: "Other",
  },
];

export const additionalInsuredFormSchema = object<AdditionalInsuredInput>({
  firstName: firstName(),
  lastName: lastName(),
  relationship: mixed<Relationship>()
    .required("Relationship type is required")
    .oneOf(Object.values(Relationship), "Choose valid value"),
});
